import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {Layout} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {InterviewSchedule} from 'main/stores/interview_schedules';
import {InterviewScheduleDirectoryState} from 'main/containers/recruiting/components/interview_schedules/directory/state';

const COLUMNS = [
  {
    header: 'recruiting.interview_schedules.Name',
    attribute: 'templateName',
    width: 11
  }
];

const LOCALIZATION = {
  removeModal: {
    header: 'recruiting.interview_schedules.Remove Interview Schedule',
    subHeader: 'recruiting.interview_schedules.Are you sure you want to remove this interview schedule?'
  },
  emptyState: 'recruiting.interview_schedules.No interview schedules to display'
};

const InterviewScheduleDirectoryWithState = observer(({uiState}) => {
  return (
    <Layout>
      <InteractiveTable
        uiState={uiState}
        title={t('recruiting.interview_schedules.Interview Schedules')}
        columns={COLUMNS}
        localization={LOCALIZATION}
        onRemove={model => uiState.deleteInterviewSchedule(model)}
        showAddButton={false}
        proxy={{
          type: 'async',
          modelType: types.INTERVIEW_SCHEDULE,
          model: InterviewSchedule,
          endpoint: endpoints.INTERVIEW_SCHEDULES.ALL
        }}
      />
    </Layout>
  );
});

export default withState(InterviewScheduleDirectoryWithState, InterviewScheduleDirectoryState);
